"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
require("moment/locale/fr");
moment_1.default.locale("fr");
exports.default = window["moment"] = moment_1.default;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Addons/moment-addon.ts
// module id = 39
// module chunks = 0